<template>
  <Modal
    v-model="modelIndex"
    width="600"
    class="applyModel"
    :mask-closable = "false"
  >
    <div slot="header">
      <p>{{title}}</p>
    </div>
    <p class="one-desc">{{summary}}</p>
    <div slot="footer">
        <button @click="goApply">前往申请</button>
    </div>
  </Modal>
</template>

<script>
export default {
  computed: {
  },
  data () {
    return {
      title: '',
      summary: '',
      modelIndex: false,
      info_src: 0
    }
  },
  methods: {
    goApply() {
      this.$parent.haddleApplyTry2(this.info_src)
    }
  }
}
</script>

<style lang="stylus" scoped>
.applyModel
  >>> .ivu-form-item-error-tip
    padding-top: 3px
    color: #FC3B3B
  >>> .ivu-modal-close
    top: 10px
    &:hover
      i
        color: #FA7A50
  >>> .ivu-modal
    .ivu-modal-content
      border-radius: 0
      background-clip: initial
      .ivu-modal-header
        position: relative
        padding: 18px 24px
        font-size: 0
        p
          font-size: 20px
          color: #3C444F
          font-weight: bold
          padding-left: 20px
          position: relative
          &:before
            content: ''
            position: absolute
            width: 5px
            height: 18px
            background: rgba(12, 91, 222, 1)
            background: linear-gradient(0deg, rgba(244,107,69,1), rgba(255,183,94,1))
            border-radius: 3px
            top: 1px
            left: 0
      .ivu-modal-body
        padding: 24px 24px 0
      .ivu-modal-footer
        border-top: 0
        padding: 20px 0 30px
        text-align: center
        p
          font-size: 12px
          color: rgba(153, 153, 153, 1)
          margin-top: 12px
        button
          background: rgba(250, 122, 80, 1)
          color: #fff
          width: 120px
          height: 36px;
          border: 0
          font-size: 14px
          border-radius: 2px
          cursor: pointer
          &:hover
            background: #FC9C7C
</style>
